import { createAction, props } from '@ngrx/store'
import { CustomerPaymentMethodsEntity } from './customer-payment-methods.models'
import { HttpErrorResponse } from '@angular/common/http'
import { ProfilesEntity } from 'libs/gb-dashboard/user/data-access/src/lib/+state/profiles.models'
import { EventTicketProfileEntity } from 'libs/shared/event-tickets/data-access/src/lib/+state/base-event-tickets.models'

export const loadCustomerPaymentMethods = createAction(
  '[CustomerPaymentMethods Page] Load Customer Payment Methods',
  props<{ stripeCustomerUuid: string }>(),
)

export const loadCustomerPaymentMethodsSuccess = createAction(
  '[CustomerPaymentMethods/API] Load CustomerPaymentMethods Success',
  props<{ customerPaymentMethods: CustomerPaymentMethodsEntity[] }>(),
)

export const loadCustomerPaymentMethodsFailure = createAction(
  '[CustomerPaymentMethods/API] Load CustomerPaymentMethods Failure',
  props<{ error: HttpErrorResponse }>(),
)

export const openPaymentMethodsDialog = createAction(
  '[CustomerPaymentMethods/Page] Open Event Guest Payment Methods Dialog',
  props<{ profile: EventTicketProfileEntity | ProfilesEntity | null }>(),
)

export const clearCustomerPaymentMethods = createAction('[CustomerPaymentMethods Page] Clear CustomerPaymentMethods')
